import React from 'react';
import styled from 'styled-components';
import { FaCalendarAlt, FaClock, FaGlobe, FaRupeeSign } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';
import Button from '../common/Button';

const FeaturedSection = styled.section`
  padding: 80px 0;
`;

const FeaturedCard = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borders.radius.regular};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.regular};
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const CourseImage = styled.div`
  flex: 1;
  position: relative;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    height: 300px;
  }
`;

const CourseTag = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  background-color: ${props => props.theme.colors.accentColor};
  color: white;
  padding: 5px 15px;
  font-weight: ${props => props.theme.fontWeights.semiBold};
  border-radius: 0 ${props => props.theme.borders.radius.small} ${props => props.theme.borders.radius.small} 0;
`;

const CourseContent = styled.div`
  flex: 1;
  padding: 40px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 30px 20px;
  }
`;

const CourseTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const CourseDescription = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  margin-bottom: 20px;
  line-height: 1.7;
`;

const CourseMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  
  svg {
    color: ${props => props.theme.colors.primaryColor};
    margin-right: 10px;
    font-size: 1.2rem;
  }
  
  span {
    color: ${props => props.theme.colors.grey[700]};
    font-weight: ${props => props.theme.fontWeights.medium};
  }
`;

const CourseActions = styled.div`
  display: flex;
  gap: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

const FeaturedCourseSection = () => {
  return (
    <FeaturedSection>
      <div className="container">
        <SectionHeader 
          title="Featured Course" 
          subtitle="Our most popular program" 
        />
        
        <FeaturedCard>
          <CourseImage>
            <img src="/placeholder/500/300" alt="TNPSC Exam Coaching" />
            <CourseTag>Featured</CourseTag>
          </CourseImage>
          
          <CourseContent>
            <CourseTitle>TNPSC Combined Technical Services Examination Coaching</CourseTitle>
            <CourseDescription>
              Comprehensive coaching for Junior Draughting Officer & Overseers positions with proven success rate.
              This course covers all aspects of the examination, providing you with the knowledge and strategies needed to excel.
            </CourseDescription>
            
            <CourseMeta>
              <MetaItem>
                <FaCalendarAlt />
                <span>Start Date: April 2, 2025</span>
              </MetaItem>
              <MetaItem>
                <FaClock />
                <span>Duration: 1.5 Months</span>
              </MetaItem>
              <MetaItem>
                <FaGlobe />
                <span>Mode: Online</span>
              </MetaItem>
              <MetaItem>
                <FaRupeeSign />
                <span>Fee: ₹9,900 + GST</span>
              </MetaItem>
            </CourseMeta>
            
            <CourseActions>
              <Button to="/tnpsc" variant="primary">Course Details</Button>
              <Button to="/contact" variant="secondary">Enroll Now</Button>
            </CourseActions>
          </CourseContent>
        </FeaturedCard>
      </div>
    </FeaturedSection>
  );
};

export default FeaturedCourseSection;
